"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROLLING_CALCULATION_WHITELIST = exports.RollingCalculationType = void 0;
var RollingCalculationType;
exports.RollingCalculationType = RollingCalculationType;

(function (RollingCalculationType) {
  RollingCalculationType["SUM"] = "sum";
  RollingCalculationType["AVERAGE"] = "average";
})(RollingCalculationType || (exports.RollingCalculationType = RollingCalculationType = {}));

var ROLLING_CALCULATION_WHITELIST = ['calculationDuration', 'calculationFrequency', 'calculationType', 'groupId', 'id', 'logProjectId', 'name', 'notes', 'projectId', 'resourceId', 'resourceType', 'units', 'versionSyncStartedAt', 'versionSyncCompletedAt'];
exports.ROLLING_CALCULATION_WHITELIST = ROLLING_CALCULATION_WHITELIST;